import type React from 'react';
import type { AIToolComponent } from '../../components/chat-messages/GuardianMarkdown';
import { useCanSplitLayout } from '../hooks/useCanSplitLayout';
import { belongsInPanel, getPlacement } from '../placement';
import { PanelPortal } from './PanelPortal';

type PanelBoundaryProps = {
  component: AIToolComponent<unknown>;
  componentName: string;
  params: unknown;
  messageId?: string;
  isLastResponse?: boolean;
};

export const PanelBoundary: React.FC<PanelBoundaryProps> = ({
  component: Component,
  componentName,
  params,
  messageId,
  isLastResponse,
}) => {
  const canSplit = useCanSplitLayout();

  if (canSplit && belongsInPanel(Component)) {
    return (
      <PanelPortal
        messageId={messageId ?? ''}
        componentName={componentName}
        params={params}
        placement={getPlacement(Component, params)}
      />
    );
  }

  return <Component params={params} isLastResponse={isLastResponse} />;
};
